import { Layout } from "antd";
import Particles from "react-particles-js";
import { BigStopWatch } from "../component/BigStopWatch";

export const Home = () => {
  return (
    <Layout style={{ background: "#141414", height: "105vh" }}>
      <Particles
        params={{
          particles: {
            number: {
              value: 150,
            },
            size: {
              value: 4,
            },
          },
          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
            },
          },
        }}
      />
      <div
        style={{
          paddingTop: "7rem",
          width: "100%",
          position: "absolute",
          alignSelf: "center",
          display: "flex",
        }}
      >
        <BigStopWatch />
      </div>
    </Layout>
  );
};
